var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { forwardRef } from "react";
import styled from "@emotion/styled";
import { SPACE_LIST, SPACE_SIZE } from "../../Designs";
var BoxWrapper = styled("div")(function (props) {
    var flexBox = props.flexBox, direction = props.direction, justifyContent = props.justifyContent, alignItems = props.alignItems, width = props.width, height = props.height, padding = props.padding, paddingX = props.paddingX, paddingY = props.paddingY;
    var styleText = "\n        display: ".concat(flexBox ? "flex" : "block", ";\n        flex-direction: ").concat(direction, ";\n        justify-content: ").concat(justifyContent, ";\n        align-items: ").concat(alignItems, ";\n    ");
    if (width) {
        styleText += "width: ".concat(width).concat(typeof width === "number" ? "px" : "", ";");
    }
    if (height) {
        styleText += "height: ".concat(height).concat(typeof height === "number" ? "px" : "", ";");
    }
    if (paddingX) {
        styleText += "\n            padding-left: ".concat(typeof paddingX === "number" ? paddingX * 4 : paddingX).concat(typeof paddingX === "number" ? "px" : "", ";\n            padding-right: ").concat(typeof paddingX === "number" ? paddingX * 4 : paddingX).concat(typeof paddingX === "number" ? "px" : "", ";\n        ");
        if (SPACE_LIST.includes("".concat(paddingX))) {
            styleText += "padding-left: ".concat(SPACE_SIZE[paddingX], ";padding-right: ").concat(SPACE_SIZE[paddingX], ";");
        }
    }
    if (paddingY) {
        styleText += "\n            padding-top: ".concat(typeof paddingY === "number" ? paddingY * 4 : paddingY).concat(typeof paddingY === "number" ? "px" : "", ";\n            padding-bottom: ").concat(typeof paddingY === "number" ? paddingY * 4 : paddingY).concat(typeof paddingY === "number" ? "px" : "", ";\n        ");
        if (SPACE_LIST.includes("".concat(paddingY))) {
            styleText += "padding-top: ".concat(SPACE_SIZE[paddingY], ";padding-bottom: ").concat(SPACE_SIZE[paddingY], ";");
        }
    }
    if (padding) {
        styleText += "padding: ".concat(typeof padding === "number" ? padding * 4 : padding).concat(typeof padding === "number" ? "px" : "", ";");
        if (SPACE_LIST.includes("".concat(padding))) {
            styleText += "padding: ".concat(SPACE_SIZE[padding]);
        }
    }
    return styleText;
});
/**
 *
 * Box is the most abstract component on top of which all other Miever UI components are built. By default, it renders a `div` element
 *
 *  ```javascript
 *      import { Box } from 'miever_components';
 *  ```
 * @param BoxProps
 * @returns
 */
var Box = forwardRef(function (props, ref) {
    var className = props.className;
    return React.createElement(BoxWrapper, __assign({}, props, { ref: ref, className: className }));
});
export default Box;
